<!--
 * @Description:
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<template>
  <div class="comp-ly-fields">
    <template v-for="(f, index) in abstractList" :key="f.id">
      <template v-if="index <= indexPart">
        <!-- 二级分组 -->
        <template v-if="f.type == 10">
          <div class="form-tab-content">
            <fh-tab-page :record="[f]"></fh-tab-page>
          </div>
        </template>
        <!-- 0是1/2行展示，1是整行 2是1/3  3是2/3行展示 -->
        <template v-if="f.type === '20'">
          <div v-if="isShowField(f?.setting?.fieldKey, ruleFields, f?.display)" :class="getFieldClass(f)" @mousemove="cellMouseEnter(f)">
            <div class="fields-content-field-label-toast form-label-text">
              <span class="fields-icon"><component :is="getFieldIcon(f?.setting?.fieldType)" class="field-icon" /></span>
              <xl-label-text :value="f.setting?.fieldName" :row="1" width="auto" class="fields-content-field-label" :key="expandCollapse" />
              <div class="fields-content-field-toast" v-if="f.toast">
                <jw-tooltip>
                  <qfei-icon-question-mark-outlined size="14" />

                  <template #content> {{ f.toast }}</template>
                </jw-tooltip>
              </div>
            </div>
            <div class="fields-content-field-value-memo show-detail">
              <!-- 飞书合同的特殊处理 -->
              <!-- <template v-if="f.setting?.fieldKey === 'fsContractId'">
                <template v-if="f?.fieldValue">
                  <jw-link v-if="fsContract" :href="fsContract" target="_blank">{{ f?.fieldValue }}</jw-link>
                  <span v-else>{{ f.fieldValue }}</span>
                </template>
                <span v-else>-</span>
              </template> -->

              <div class="fields-content-field-value">
                <fh-field-show :params="setFieldParams(f)" />
              </div>

              <div class="fields-content-field-memo" v-if="f.memo">
                {{ f.memo }}
              </div>
            </div>
          </div>
        </template>
        <!-- 引用对象字段，功能已经能下架，兼容老用户配置 -->
        <template v-else-if="f.type === '50'">
          <div :class="getFieldClass(f)">
            <div class="fields-content-field-label-toast">
              <span class="fields-icon"><component :is="getFieldIcon(f?.setting?.fieldType)" class="field-icon" /></span>
              <xl-label-text :value="f.setting?.fieldName" :row="1" width="auto" class="fields-content-field-label" :key="expandCollapse" />
            </div>
            <div class="fields-content-field-value-memo show-detail">
              <div class="fields-content-field-value quote-field-value" v-if="f?.fieldValue">
                <template v-if="f?.setting?.fieldType == 16">
                  {{ tools.getPriceShow(f?.fieldValue, f?.setting?.fieldExt) || '-' }}
                </template>
                <template v-else-if="f?.setting?.fieldType == 7 && tools.isJSON(f.setting?.fieldExt)"> {{ tools.getNumberShow(f.fieldValue, f.setting?.fieldExt) }}{{ JSON.parse(f.setting?.fieldExt)?.numberUnit ? JSON.parse(f.setting?.fieldExt)?.numberUnit : '' }} </template>
                <template v-else-if="f?.setting?.fieldType == 23 && tools.isJSON(f.setting?.fieldExt)">
                  {{ tools.getPercentage(f?.fieldValue, f?.setting?.fieldExt) + '%' || '-' }}
                </template>
                <template v-else-if="f?.setting?.fieldType == 24">
                  <template v-if="f.setting?.fieldExt && tools.isJSON(f.setting?.fieldExt)">
                    <!-- 汇总金额，金额 todo计算字段 -->
                    <template v-if="JSON.parse(f?.setting?.fieldExt).type == 6 || JSON.parse(f?.setting?.fieldExt).type == 16">
                      {{ f?.fieldValue ? tools.getPriceShow(f?.fieldValue, f?.setting?.fieldExt) : '-' }}
                    </template>
                    <!-- 百分比 -->
                    <template v-else-if="JSON.parse(f?.setting?.fieldExt)?.type === 23">
                      {{ f?.fieldValue ? tools.getPercentage(f?.fieldValue, f?.setting?.fieldExt) + '%' : '-' }}
                    </template>
                    <!-- 数字，汇总数字 -->
                    <template v-else-if="JSON.parse(f?.setting?.fieldExt).type == 5 || JSON.parse(f?.setting?.fieldExt).type == 7">
                      <template v-if="!isNaN(parseFloat(f.fieldValue))">
                        <span>{{ tools.getNumberShow(f.fieldValue, f.setting?.fieldExt) }}</span>
                      </template>
                      <template v-else>-</template>
                    </template>
                    <!-- 其他类型 -->
                    <span v-else>
                      {{ f?.fieldValue || '-' }}
                    </span>
                  </template>
                </template>
                <template v-else>
                  {{ f.fieldValue?.length > 0 ? f.fieldValue?.join() : '-' }}
                </template>
              </div>
              <!-- <div class="fields-content-field-memo" v-if="f.memo">{{ f.memo }}</div> -->
            </div>
          </div>
        </template>
        <!-- 查询记录，关联记录 -->
        <template v-else-if="getRecordType(f.type)">
          <div :class="['box-table', 'vertical-table']" v-if="f.modules?.length && isShowField(f?.value, ruleFields, f?.display)">
            <div class="fields-box" v-if="permission == 1 && (getButton(f) || f.label)">
              <div class="fields-label">
                <span class="fields-icon"><component :is="fieldIconMapping[Number(f.type)]" /></span>

                <xl-label-text :value="setRecordLabel(f)" :row="1" width="auto" class="fields-content-field-label" :key="expandCollapse" />
              </div>
              <div class="table-handle-btn">
                <jw-trigger trigger="click" unmount-on-close position="br" v-if="isShowFilter">
                  <jw-button type="outline">
                    <template #icon>
                      <icon-filter />
                    </template>
                    <jw-space>
                      <span>
                        <span>筛选</span>
                        <span v-if="numCount > 0">+{{ numCount }}</span>
                      </span>
                      <icon-delete class="icon-delete" v-if="numCount > 0" @click="clearCondition" />
                    </jw-space>
                  </jw-button>
                  <template #content>
                    <div class="demo-basic">
                      <custom-field-condition ref="lyTableRef" :filter="false" :height="200" :entity="f.businessData" @cb="getConditions($event, index)" isDetailTable isScreen :children="filterParams"></custom-field-condition>
                    </div>
                  </template>
                </jw-trigger>
                <template v-for="(b, i) in f.modules">
                  <jw-button class="table-btn-add" type="text" size="small" :key="i" v-if="isShowAdd(b, f) && isEditableField([f?.value, f?.id], ruleFields, f?.attributeRead?.length && f?.attributeRead?.includes('3') ? 0 : 1)" @click="toUpdate(f)"><qfei-icon-add-two-outlined />{{ $t('新建') }}</jw-button>
                </template>
              </div>
            </div>
            <!-- 过滤type=40的操作按钮字段 -->
            <div class="fields-table-container">
              <fh-detail-table style="padding: 0 0" :tId="f.id" :ref="(e) => setRealTableRef(e, f?.id)" :column="f.modules?.filter((mf) => mf?.type != 40 || isEditableField(f?.value, ruleFields, f?.attributeRead?.length && f?.attributeRead?.includes('3') ? 0 : 1))" :isCanEdit="isEditableField(f?.value, ruleFields, f?.attributeRead?.length && f?.attributeRead?.includes('3') ? 0 : 1)" :list="f?.fieldValue" :layoutConfigId="f?.id" :businessData="f.businessData" :layoutId="f.layoutId"></fh-detail-table>
            </div>
          </div>
        </template>
        <!-- 子表单 -->
        <template v-else-if="f.type === '35'">
          <div :class="['box-table', 'vertical-table']" v-if="f.modules?.length && isShowField(f?.value, ruleFields, f?.display)">
            <div class="fields-box" v-if="f?.label">
              <div class="fields-label">
                <span class="fields-icon"><component :is="fieldIconMapping[35]" /></span>
                <xl-label-text :value="f.label" :row="1" width="auto" class="fields-content-field-label" :key="expandCollapse" />
              </div>
            </div>
            <div class="fields-table-container">
              <!-- 过滤type=40的操作按钮字段 .filter((v) => v.type != 40) subform.fieldkey -->
              <fh-detail-table style="padding: 0 0" :subformFieldKey="f?.value" :subformRuleFields="ruleFields" :attributeRead="f?.attributeRead" :column="f.modules?.filter((fm) => isShowField(`${f.value}.${fm?.setting?.fieldKey}`, ruleFields, fm?.display))" :list="f?.fieldValue" type="35" :layoutConfigId="f?.id" :businessEntity="entity" :businessData="f.businessData" :layoutId="f.layoutId"></fh-detail-table>
            </div>
          </div>
        </template>
        <!-- 外链容器 -->
        <template v-else-if="f?.type === '60'">
          <xl-iframe
            class="frame-online"
            v-if="getFrameData(f)?.pcUrl"
            :query="{
              businessId: detailAllFields?.id,
              entity: entity,
              viewId: viewId
            }"
            :height="getFrameData(f)?.height"
            :src="getFrameData(f)?.pcUrl"
            :border="getFrameData(f)?.borderType"
          />
        </template>
        <template v-if="abstractList?.length - 1 > 13">
          <div class="get-more-content" v-if="index == indexPart" @click="getMore(abstractList)">
            <span class="get-more">{{ down ? '展开更多' : '折叠' }}</span>
            <icon-down v-if="down" />
            <icon-up v-else />
          </div>
        </template>
      </template>
    </template>
  </div>
  <!--新建/编辑弹窗 -->
  <fh-add-edit ref="addEditRef" @cb="updateTableData" :from="2" />
</template>

<script setup>
import { computed, inject, ref, nextTick, reactive, defineAsyncComponent } from 'vue';
import { tools } from '@/utils/tools.js';
import XlIframe from '@/components/xl-iframe/xl-iframe.vue';
import FhDetailTable from '@/components/fh-detail-table/fh-detail-table.vue';
import useFields from '@/hooks/fields';
const { fieldIconMapping } = useFields(); // 获取字段图标
import fieldPermission from '@/hooks/field-permission';
import { QfeiIconQuestionMarkOutlined } from '@qfei-design/icons-vue';
import { emptyText } from '@/utils/const';
const { isShowField, isEditableField, isRequiredField } = fieldPermission();
import useObjectForm from '@/hooks/object-form';
const { getRecordType, setRecordLabel } = useObjectForm();

const props = defineProps({
  record: {
    //字段列表
    type: Array,
    default: () => []
  }
});
// 获取字段图标
const getFieldIcon = (fieldType) => {
  return fieldIconMapping.value[Number(fieldType)];
};
// import { useRouter } from 'vue-router';
import { useUserStore } from '@/store';

const FhFieldShow = defineAsyncComponent(() => import('@/components/fh-set-fields/field-detail-main/index.vue'));

const { userInfo } = useUserStore();
// const texts = tools.getAllOptText(userInfo?.menus?.entityResources);
const entity = inject('detailParams')?.entity;
const expandCollapse = inject('detailParams')?.expandCollapse;
const computedError = inject('detailParams')?.computedError; // 计算字段错误信息
const permission = inject('detailParams')?.permission;
const detailAllFields = inject('detailParams')?.detailAllFields;
const viewId = inject('globalParams')?.viewId === -1 ? '' : inject('defaultParams')?.viewId ? inject('defaultParams').viewId : ''; //视图ID
const detailRefresh = inject('detailParams')?.detailRefresh;
const locked = inject('detailParams')?.locked; //锁定状态
const ruleFields = inject('detailParams')?.ruleFields;
const layoutMainField = inject('detailParams')?.layoutMainField || {};
// console.log('detailAllFields-----', detailAllFields.value);
const allowAddObject = ref(['clue:add', 'customer:add', 'businessOpportunity:add', 'product:add', 'priceSheet:add', 'contract:add', 'saleOrder:add', 'returnOrder:add', 'afterSale:add']);
const abstractList = computed(() => props.record);
const layoutDetailConfig = inject('detailParams')?.layoutDetailConfig.value; //详情配置
// const indexPart = ref(13);
const indexPart = ref(9999);
const down = ref(false);
const addEditRef = ref(); // 新建/编辑弹窗
const getMore = (fieldList) => {
  down.value = !down.value;
  indexPart.value = down.value ? 13 : fieldList?.length - 1;
};
const getFrameData = (module) => {
  if (module?.businessData && tools.isJSON(module?.businessData) && module?.additionalBusiness && tools.isJSON(module?.additionalBusiness)) {
    return {
      ...JSON.parse(module?.businessData),
      ...JSON.parse(module?.additionalBusiness)
    };
  }

  return {};
};

//给form绑定类名
const getFieldClass = (f) => {
  // 基础类名
  const baseClass = ['fields-content-field'];

  // 根据展开状态计算基础宽度类名（默认1/2行展示）
  const baseWidthClass = expandCollapse.value ? ['expand-middle', 'one-half-width-middle'] : ['expand-large', 'one-half-width-large'];

  // 根据 displayOneLine 计算布局类名
  let layoutLineClass = [];
  let layoutClass = [];
  //   兼容历史数据（ 0是1/2行展示，1是整行 2是1/3  3是2/3行展示）
  if (f?.displayOneLine && !isNaN(parseFloat(f?.displayOneLine))) {
    if (f?.displayOneLine === 2) {
      layoutLineClass = expandCollapse.value ? ['form-two-line', 'two-line-width-middle'] : ['form-two-line', 'two-line-width-large'];
    } else if (f?.displayOneLine === 3) {
      layoutLineClass = expandCollapse.value ? ['form-three-line', 'three-line-width-middle'] : ['form-three-line', 'three-line-width-large'];
    } else if ([18, 26].includes(f?.setting?.fieldType) || f?.displayOneLine === 1) {
      layoutLineClass = expandCollapse.value ? ['form-online', 'line-width-middle'] : ['form-online', 'line-width-large'];
    }
  } else {
    //新数据 displayOneLine：1 单列，2：两列

    if (layoutDetailConfig?.displayOneLine == 1) {
      //单列
      layoutLineClass = expandCollapse.value ? ['form-online', 'line-width-middle'] : ['form-online', 'line-width-large'];
    }
    if ([18, 26].includes(f?.setting?.fieldType)) {
      layoutLineClass = expandCollapse.value ? ['form-online', 'line-width-middle'] : ['form-online', 'line-width-large'];
    }
  }

  if (layoutDetailConfig?.formLayout == 1) {
    //上下布局
    layoutClass = ['form-vertical'];
  }

  // 合并所有类名并去重
  return [...new Set([...baseClass, ...baseWidthClass, ...layoutLineClass, ...layoutClass])];
};
// 是否可编辑
const isShowFilter = ref(false);

// 梳理字段显示需要的参数
const setFieldParams = (item) => {
  const fieldType = item?.setting?.fieldType == 21 ? item?.setting?.business?.fieldType ?? 21 : item?.setting?.fieldType;
  const fieldExt = item?.setting?.fieldType == 21 ? item?.setting?.business?.fieldExt : item?.setting?.fieldExt;
  //   const _concatSetting = {
  //     isRequired: isRequiredField(item?.setting?.fieldKey, ruleFields.value, item?.setting?.isRequired)
  //   };
  const params = {
    col: { ...item?.setting },
    row: { ...item, lockedOrigin: locked.value, id: detailAllFields.value?.id, computedInfo: computedError?.value?.length ? computedError?.value?.[0] : null, fsContractMultiUrl: detailAllFields.value?.fsContractMultiUrl, fsContractId: detailAllFields.value?.fsContractId }, // 使用子表单中的数据
    fieldValue: item.fieldValue,
    fieldType: fieldType,
    fieldKey: item?.setting?.fieldKey,
    fieldExt: fieldExt,
    isRequired: isRequiredField(item?.setting?.fieldKey, ruleFields.value, item?.setting?.isRequired),
    isSubForm: false,
    mainField: item?.setting?.mainField,
    entity: entity.value,
    sourceType: 2, //1:列表 2：详情
    permissions: permission.value, //权限
    PERMISSION: ruleFields.value,
    showEmptyType: emptyText
  };
  return params;
};

// 是否有新建按钮
const getButton = (f) => {
  var obj = null;
  if (f?.modules?.length > 0) {
    f?.modules.forEach((b) => {
      if (b?.value?.includes(':add') && (allowAddObject.value?.indexOf(b.value) > -1 || f?.businessData >= 200) && userInfo?.roles?.indexOf(b.value) > -1) {
        obj = b;
      }
    });
  }
  return obj;
};
// const fsContract = computed(() => {
//   const cu = tools.isJSON(detailAllFields.value?.fsContractMultiUrl) && JSON.parse(detailAllFields.value?.fsContractMultiUrl);
//   return cu?.pc_url ? cu.pc_url : '';
// });
//表格动态ref
const realLyTableRef = reactive({}); //表格ref
const createTableId = ref(null); //当前点击新建的表格id
const setRealTableRef = (e, id) => {
  realLyTableRef[id] = e;
};
const isShowAdd = (b, f) => {
  //如果自定义对象b的value等于businessData+:add或者是系统对象的新增  并且  有权限
  return (b?.value == f.businessData + ':add' || allowAddObject.value?.indexOf(b.value) > -1) && userInfo?.roles?.indexOf(b.value) > -1;
};

const drawerRef = document.querySelector('.arco-drawer-body');
const scrollPosition = ref(0);
const updateTableData = () => {
  console.log(456, 'Update table data');
  detailRefresh?.(scrollPosition.value);
  // if (createTableId.value !== null) realLyTableRef?.[createTableId.value]?.getTableEntityData?.(1);
};

const toUpdate = (module) => {
  if (!module?.businessData) return false;
  // 在编辑开始前保存滚动位置
  scrollPosition.value = drawerRef.scrollTop;
  createTableId.value = module.id;
  const getEntityObj = {
    //设置当前对象信息
    label: detailAllFields.value?.[layoutMainField.value?.fieldKey] ?? '',
    value: detailAllFields.value?.id || '',
    fieldKey: '',
    fieldExt: entity.value, //当前对象id
    associateKey: module?.type == 30 ? module?.associateKey : '' //查找关联的关联对象key值
  };
  const params = { type: 30, viewId: -1, entity: module?.businessData, getEntityObj };

  addEditRef.value?.open(params);
};
const cellMouseEnter = (record) => {
  nextTick(() => {
    const iconList = document.getElementsByClassName('ly-edit-fields-icon');
    iconList?.forEach((i) => {
      const getUniqueValue = i?.getAttribute('uniqueValue');
      i.style.visibility = 'hidden';
      if (record.id == getUniqueValue) {
        i.style.visibility = 'visible';
        return;
      }
    });
  });
};
const numCount = ref(0);
const lyTableRef = ref();
const filterParams = ref([]);
const getConditions = async (record, index) => {
  console.log(5338, '点击筛选按钮', record, index);
  numCount.value = record?.length;
  if (record.type === 1) {
    console.log(536, lyTableRef.value);
  }
};
// 清空高级筛选项
const clearCondition = () => {
  filterParams.value = [];
};
</script>
<style scoped lang="less">
@import './index.less';
</style>
